import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from 'jquery';
let $=jQuery.noConflict();

export class ZIDXSiteHome implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxSiteHomeContainer";
    }
    render(){
        // console.log("site home");
        $(".zidxResultsContainer", this.zidx.peakidxShadowRoot).remove();
        this.zidx.zidxMap.mode="markers";
        this.zidx.zidxBase.resetForNavigation();
        this.zidx.zidxBase.init(true, false, true, true);

    }
}